<template>
  <div>
    <!-- 资格审查通过 -->
    <div class="flex-x-center" v-if="process.content.status === 1">
      <div class="profile-content">
        <div class="iconfont icon-tongguo flex-x-y-center pass-icon"></div>
        <div class="title flex-x-y-center">现场审核</div>
        <div class="qualifications flex-x-center">
          请带好相关资料在规定时间内到现场核查！
        </div>
      </div>
    </div>
    <div class="flex-x-center" v-if="process.content.status === 2">
      <div class="profile-content">
        <div class="iconfont icon-tongguo flex-x-y-center pass-icon"></div>
        <div class="title flex-x-y-center">资格审查通过</div>
      </div>
    </div>

    <!-- 资格审查中 -->
    <div class="flex-x-center" v-if="process.content.status === 0">
      <div class="profile-content">
        <div class="iconfont icon-jinhangzhong flex-x-y-center advisement-icon"></div>
        <div class="title flex-x-y-center">资格审查中</div>
      </div>
    </div>

    <!-- 资格审查不通过（改报被驳回） -->
    <div class="flex-x-center" v-if="process.content.status === -1">
      <div class="profile-content">
        <div class="iconfont icon-cuowu flex-x-y-center unpassd-icono"></div>
        <div class="title flex-x-y-center">未通过资格审查</div>
        <div class="qualifications flex-x-center">
          {{ process.content.message }}
        </div>
        <div class="flex-x-center" style="margin-top:10px; color: #909399; font-size: 14px;" v-if="process.content.change_count > 0">
          改报申请已被驳回，无法再次改报
        </div>
      </div>
    </div>

    <!-- 资格审查退回（可以重新改报） -->
    <div class="flex-x-center" v-if="process.content.status === -3">
      <div class="profile-content">
        <div class="iconfont icon-cuowu flex-x-y-center unpassd-icono"></div>
        <div class="title flex-x-y-center">资格审查已退回</div>
        <div class="qualifications flex-x-center">
          {{ process.content.message }}
        </div>
        <div class="flex-x-center" style="margin-top:10px; color: #909399; font-size: 14px;" v-if="process.content.change_limit > 0">
          当前已改报 {{ process.content.change_count || 0 }} / {{ process.content.change_limit }} 次
        </div>
        <div class="flex-x-center" style="margin-top:20px;" v-if="process.content.change_count < process.content.change_limit">
           <el-button type="primary" size="medium" @click="goToKqgb()">返回重新改报</el-button>
        </div>
      </div>
    </div>

    <!-- 驳回（可重新改报） -->
    <div class="flex-x-center" v-if="process.content.status === -2">
      <div class="profile-content">
        <div class="iconfont icon-cuowu flex-x-y-center unpassd-icono"></div>
        <div class="title flex-x-y-center">改报申请已被驳回</div>
        <div class="qualifications flex-x-center">
          {{ process.content.message }}
        </div>
        <div class="flex-x-center" style="margin-top:10px; color: #909399; font-size: 14px;" v-if="process.content.change_limit > 0">
          当前已改报 {{ process.content.change_count || 0 }} / {{ process.content.change_limit }} 次
        </div>
        <div class="flex-x-center" style="margin-top:20px;" v-if="process.content.change_count < process.content.change_limit">
           <el-button type="primary" size="medium" @click="goToKqgb()">返回重新改报</el-button>
        </div>
      </div>
    </div>

    <div class="flex-x-center agree-sign-next" v-if="process.content.status > 1">
      <button v-show="process.enable == 1" class="next-step" @click="$parent.next()">
        下一步
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    async goToKqgb() {
      let processList = this.$parent.projectDetail.process || [];
      let kqgbIndex = processList.findIndex(p => p.name === 'kqgb');
      if (kqgbIndex !== -1) {
        // 同步后端进度
        try {
          await this.$parent.reqProjectSavedata({
            project_id: this.$parent.projectDetail.project_info.id,
            current_step: kqgbIndex
          });
          
          localStorage.setItem('active', kqgbIndex);
          localStorage.setItem('currentStepName', 'kqgb');
          this.$parent.step_name = 'kqgb';
          this.$parent.reload();
        } catch (e) {
          this.$message.error("进度同步失败，请重试");
        }
      } else {
        this.$message.error("改报入口暂未开启");
      }
    }
  },

  props: {
    // 流程
    process_index: {
      type: Number,
      default: 0
    },
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
};
</script>

<style scoped>
.qualifications {
  color: rgb(219, 122, 65);
  letter-spacing: 1px;
  margin-top: 20px;
}

.unpassd-icono {
  font-size: 60px;
  color: #b8000d;
}

.advisement-icon {
  font-size: 60px;
  color: rgb(37, 110, 206);
}

.pass-icon {
  font-size: 60px;
  color: rgb(50, 187, 62);
}

.profile-content {
  margin-top: 20px;
  width: 83%;
  padding: 40px 50px 80px;
  background: white !important;
  border-radius: 5px;
  box-sizing: border-box;
}
</style>
